import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function VerDescuentoFlota({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [d, setD] = useState(null);

  useEffect(() => {
    if (!id) return;
    const abort = new AbortController();

    async function load() {
      setLoading(true);
      setErr("");
      try {
        const data = await appFetchJson(
          apiRoutes.descuentoFlota.detail(id),
          { signal: abort.signal }
        );
        setD(data);
      } catch (e) {
        if (e?.name !== "AbortError") {
          setErr(e?.message || "Error al cargar el descuento.");
        }
      } finally {
        setLoading(false);
      }
    }

    load();
    return () => abort.abort();
  }, [id]);

  const rows = [
    ["Cliente", d?.clienteNombre],
    ["EE.SS.", d?.eessNombre || "TODAS"],
    ["Producto", d?.productoNombre || "TODOS"],
    ["Tarjeta", d?.tarjetaNumero || "TODAS"],

    ["Total Descuento Valor PYG", d?.valorDescuento],
    ["Valor PYG EE.SS.", d?.valorEess],
    ["Valor PYG Petrobras", d?.valorPetr],
    ["Total Descuento %", d?.porcentajeDescuento],
    ["EE.SS. %", d?.porcentajeEess],
    ["Petrobras %", d?.porcentajePetr],

    ["Fecha Inicio", d?.fechaInicio],
    ["Fecha Fin", d?.fechaFin],
    ["Vigente", d?.vigente ? "Sí" : "No"],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">Datos de Descuento Flota</h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">Cargando…</div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">{err}</div>
          )}

          {!loading && !err && d && (
            <div className="form-grid">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value ?? ""}</div>
    </div>
  );
}
